module.exports = __webpack_public_path__ + "resource/img/shelve-icon.0cd67fd4.png";